const STORAGE_KEY_CATEGORIES_SCROLL = "lookiero:shop:categories:scroll";
const STORAGE_KEY_HAS_CATEGORIES_NOTIFICATION_SHOWED = "lookiero:shop:home:hasNotificationShowed";
const STORAGE_KEY_HOME_SCROLL = "lookiero:shop:home:scroll";
const STORAGE_KEY_PRODUCT_DETAIL_SCROLL = "lookiero:shop:product-detail:scroll";
const STORAGE_KEY_TRENDING_FOR_YOU_SCROLL = "lookiero:shop:trending-for-you:scroll";
const STORAGE_KEY_ONGOING_ORDER_ID = "lookiero:shop:ongoing-order-id";

export {
  STORAGE_KEY_CATEGORIES_SCROLL,
  STORAGE_KEY_HAS_CATEGORIES_NOTIFICATION_SHOWED,
  STORAGE_KEY_HOME_SCROLL,
  STORAGE_KEY_PRODUCT_DETAIL_SCROLL,
  STORAGE_KEY_TRENDING_FOR_YOU_SCROLL,
  STORAGE_KEY_ONGOING_ORDER_ID,
};
